/* unplugin-vue-components disabled */import script from "./promotionMyList.vue?vue&type=script&setup=true&lang=js"
export * from "./promotionMyList.vue?vue&type=script&setup=true&lang=js"

import "./promotionMyList.vue?vue&type=style&index=0&id=503c788d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503c788d"]])

export default __exports__